import ReactGA from 'react-ga4';

/**
 * Sends a pageview event to Google Analytics.
 * @param {string} path - The page path (e.g. '/contract/make_contract')
 * @param {string} [title] - Optional page title
 */
export const trackPageView = (path, title) => {
  ReactGA.send({ hitType: 'pageview', page: path, title });
};

/**
 * Sends a custom event to Google Analytics.
 * @param {string} category - Event category (e.g. 'Contract Form')
 * @param {string} action - Event action (e.g. 'step_completed')
 * @param {string} [label] - Optional label for additional detail
 * @param {number} [value] - Optional numeric value
 */
export const trackEvent = (category, action, label, value) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

/**
 * Sets user properties in Google Analytics (custom dimensions).
 * @param {object} properties - Key-value pairs (e.g. { device_type: 'mobile' })
 */
export const setUserProperties = (properties) => {
  ReactGA.gtag('set', 'user_properties', properties);
};

/**
 * Sets up a beforeunload listener to track form abandonment.
 * Returns a cleanup function to remove the listener.
 * @param {function} getStep - Function that returns the current step index
 * @param {string[]} stepNames - Array of step names
 * @returns {function} cleanup - Call this to remove the listener
 */
export const trackFormAbandonment = (getStep, stepNames) => {
  const handler = () => {
    const step = getStep();
    trackEvent('Contract Form', 'form_abandoned', stepNames[step], step);
  };
  window.addEventListener('beforeunload', handler);
  return () => window.removeEventListener('beforeunload', handler);
};
